// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"23":"agenda","443":"about","650":"upload"}[chunkId] + "." + {"23":"152c91e7","443":"b7d5b702","650":"440afbe3"}[chunkId] + ".css";
};